import React from 'react';
import PropTypes from 'prop-types';
import styles from './Tables.module.css';

const ComparisonChangeValue = ({ value, noColor }) => {
  const delta = parseFloat(value);

  let colorClass = '';
  if (!noColor) {
    if (delta < 0) colorClass = styles.pos;         // green
    else if (delta <= 5) colorClass = styles.negSoft; // orange
    else colorClass = styles.neg;  
  }

  return <span className={`${styles.change} ${colorClass}`}>({delta}%)</span>;
};

export default ComparisonChangeValue;

ComparisonChangeValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  noColor: PropTypes.bool,
};

ComparisonChangeValue.defaultProps = {
  noColor: false,
};
